///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum TunnelListType {
    WITH_SINGLE_TUNNELS = 'withSingleTunnels',
    WITHOUT_TUNNELS = 'withoutTunnels'
}
